import { render, staticRenderFns } from "./lower_abdomen.vue?vue&type=template&id=4db19cc0"
import script from "./lower_abdomen.vue?vue&type=script&lang=js"
export * from "./lower_abdomen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports